<template>
  <BaseDropdown
    class="filter-dropdown"
    :button-class="['py-4 px-4 lg:px-8 border-t border-light focus-visible:bg-grey-50', { 'bg-gradient-to-b from-surface-raised to-surface-raised/90 sticky top-0 z-10': open }]"
    content-class="filter-dropdown-content overflow-y-auto pt-2 pb-4 px-4 lg:px-8"
    @dropdown-toggle="toggle"
  >
    <template #button>
      <div class="flex justify-between items-center gap-6">
        <span>
          {{ label }}
        </span>
        <span class="text-xs text-red-800 min-w-0 whitespace-nowrap truncate">
          <slot name="selection" />
        </span>
      </div>
    </template>
    <slot name="default" />
  </BaseDropdown>
</template>

<script setup lang="ts">
import BaseDropdown from '~/components/BaseDropdown.vue'

defineProps({
  label: {
    type: String,
    required: true
  }
})

const open = ref<boolean>(false)
function toggle(status: boolean) {
  open.value = status
}
</script>

<style lang="scss">
.filter-dropdown {
  .base-checkbox {
    @apply h-auto;
    input {
      + label {
        @apply flex px-4 py-3;
        &:hover {
          @apply bg-grey-50;
        }
      }
      &:checked + label  {
        @apply bg-grey-100;
      }
    }
  }
}
</style>
